import React from 'react'
import { Button, Modal, Image } from 'semantic-ui-react'

const Thumbnail = ({image}) => (
  <Modal trigger={<Image as={Button} src={image} size='small' style={{padding: '10px', border: '1px solid #DDD'}}/>} basic size='fullscreen' closeOnDimmerClick closeOnDocumentClick>
    <Modal.Content>
      <Image src={image} ui={false} style={{width: '100%'}}/>
    </Modal.Content>
  </Modal>
)

export default Thumbnail


/** WEBPACK FOOTER **
 ** ./src/components/Thumbnail/index.js
 **/